import createSalaryStructure from './mutations/createSalaryStructure';
import updateSalaryStructure from './mutations/updateSalaryStructure';
import getSalaryStructure from './queries/getSalaryStructure';
import getSalaryComponentSDIs from './queries/getSalaryComponentSDIs';
import listSalaryStructures from './queries/listSalaryStructures';
import setSalaryStructureStatus from './mutations/setSalaryStructureStatus';
import getSalaryStructuresForUsers from './queries/getSalarystructuresForUsers';
import getUserIdsBySalaryStructure from './queries/getUserIdsBySalaryStructure';
import assignSalaryStructureToEmployees from './mutations/assignSalaryStructureToEmployees';

const salaryStructures = {
  queries: {
    listSalaryStructures,
    getSalaryStructure,
    getSalaryComponentSDIs,
    getSalaryStructuresForUsers,
    getUserIdsBySalaryStructure,
  },
  mutations: {
    createSalaryStructure,
    updateSalaryStructure,
    setSalaryStructureStatus,
    assignSalaryStructureToEmployees,
  },
};

export default salaryStructures;
